import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { P0, P1 } from '../../../../components/Typographies/Paragraph';
import { H3 } from '../../../../components/Typographies/Title';
import IconArrow from '../../../../images/icons/arrow.svg';
import { IDestination, IHighlightedCity } from './constants';
import { homePageDestinationsMessages } from './messages';

const DestinationImageContainer = styled.a`
  ${tw`relative rounded-30 overflow-hidden`}
  max-width:489px;
`;

const Image = styled.img`
  ${tw`w-full`}
`;

const CityName = styled(H3)`
  ${tw`absolute text-white  p-big `}
  text-align:start;

  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    359.66deg,
    rgba(58, 53, 70, 0.8) 14.55%,
    rgba(53, 55, 70, 0.391837) 63.86%,
    rgba(53, 55, 70, 0) 94.93%
  );
`;

const DestinationImage: React.FC<IHighlightedCity> = ({
  image,
  image2x,
  image3x,
  name,
  url,
}) => (
  <DestinationImageContainer href={url} rel="noreferrer" target="_blank">
    <Image
      alt={`Image of the city of ${name}`}
      src={image}
      srcSet={`
      ${image} 1x
      ${image2x && `, ${image2x} 2x`} 
      ${image3x && `, ${image3x} 3x`}
    `}
    />
    <CityName>{name}</CityName>
  </DestinationImageContainer>
);

const CardContainer = styled.div`
  ${tw`shadow-medium bg-white rounded-30 px-medium py-medium w-full h-full cursor-pointer`}
  max-width:309px;
`;

const CardImage = styled.img`
  ${tw`w-full mb-medium`}
`;

const CardDetails = styled.div`
  ${tw`flex justify-between px-medium`}
`;

const From = styled(P1)`
  ${tw`flex`}
  flex-wrap:wrap;
  column-gap: var(--size-small);
`;

const Icon = styled.img``;

interface CardProps {
  data: IDestination;
}

const Card: React.FC<CardProps> = ({ data }) => (
  <CardContainer onClick={() => window.open(data.url, '_blank')}>
    <CardImage
      alt={`Landscape of the city of ${data.name}`}
      src={data.image}
      srcSet={`
      ${data.image} 1x
      ${data.image2x && `, ${data.image2x} 2x`} 
      ${data.image3x && `, ${data.image3x} 3x`}
    `}
    />
    <CardDetails>
      <div>
        <P0>
          <strong>{data.name}</strong>
        </P0>
        <From>
          <FormattedMessage
            {...homePageDestinationsMessages.destinationsCardFrom}
          />
          <strong>
            <FormattedNumber
              currency="EUR"
              // eslint-disable-next-line react/style-prop-object
              style={'currency'}
              value={data.price}
            />
          </strong>
        </From>
      </div>

      <Icon alt="Arrow icon" src={IconArrow} />
    </CardDetails>
  </CardContainer>
);

export { Card, DestinationImage };
